import './ImageSlider.css';
import React, { useEffect, useState } from 'react';

// 이미지 파일을 import
import image1 from '../assets/img/SliderImg/1.webp';
import image2 from '../assets/img/SliderImg/2.webp';
import image3 from '../assets/img/SliderImg/3.webp';
import image4 from '../assets/img/SliderImg/4.webp';
import image5 from '../assets/img/SliderImg/5.webp';
import image6 from '../assets/img/SliderImg/6.webp';
import image7 from '../assets/img/SliderImg/7.webp';
import image8 from '../assets/img/SliderImg/8.webp';
import image9 from '../assets/img/SliderImg/9.webp';
import image10 from '../assets/img/SliderImg/10.webp';
import image11 from '../assets/img/SliderImg/11.webp';
import image12 from '../assets/img/SliderImg/12.webp';
import image13 from '../assets/img/SliderImg/13.webp';
import image14 from '../assets/img/SliderImg/14.webp';
import image15 from '../assets/img/SliderImg/15.webp';
import image16 from '../assets/img/SliderImg/16.webp';
import image17 from '../assets/img/SliderImg/17.webp';
import image18 from '../assets/img/SliderImg/18.webp';
import image19 from '../assets/img/SliderImg/19.webp';
import image20 from '../assets/img/SliderImg/20.webp';
import image21 from '../assets/img/SliderImg/21.webp';
import image22 from '../assets/img/SliderImg/22.webp';
import image23 from '../assets/img/SliderImg/23.webp';
import image24 from '../assets/img/SliderImg/24.webp';
import image25 from '../assets/img/SliderImg/25.webp';
import image26 from '../assets/img/SliderImg/26.webp';
import image27 from '../assets/img/SliderImg/27.webp';
import image28 from '../assets/img/SliderImg/28.webp';
import image29 from '../assets/img/SliderImg/29.webp';
import image30 from '../assets/img/SliderImg/30.webp';

const imagesArray = [
  image1, image2, image3, image4, image5, image6, image7, image8, image9, image10,
  image11, image12, image13, image14, image15, image16, image17, image18, image19, image20,
  image21, image22, image23, image24, image25, image26, image27, image28, image29, image30
];

// 배열을 랜덤하게 섞는 함수
const shuffleArray = (array) => {
  const shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

const ImageSlider = () => {
  const [shuffledImages, setShuffledImages] = useState([]);

  useEffect(() => {
    const shuffledArray = shuffleArray(imagesArray);
    setShuffledImages(shuffledArray);
  }, []);

  return (
    <div className="slider-container">
      <div className="slider-content">
        {shuffledImages.map((image, index) => (
          <div key={index} className="image-item">
            <img src={image} alt={`Image ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
